
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/context/LanguageContext';
import { useUserDisplayInfo } from '@/context/UserDisplayContext';
import LanguageSwitcherBackoffice from './LanguageSwitcherBackoffice';

const BackofficeNavbar = () => {
  const { t } = useLanguage();
  const { displayInfo, loading, error } = useUserDisplayInfo();

  // Format user display name
  const formatUserDisplay = () => {
    if (loading) return '...';
    if (error || !displayInfo) return 'User';
    
    const firstName = displayInfo.first_name || '';
    const username = displayInfo.username || '';
    
    if (firstName && username) {
      return `${username}`;
    } else if (firstName) {
      return firstName;
    } else if (username) {
      return `@${username}`;
    }
    return 'User';
  };

  return (
    <header className="h-16 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200 flex items-center justify-between px-6 gap-4">
      {/* User Display Section */}
      <div className="flex items-center gap-2 pl-10 text-purple-900 min-w-0 ">
        <img src="/logo_1_no_background.png" alt="TheClub" className="h-8 w-auto flex-shrink-0" />
        <span translate="no" className="text-base font-medium truncate max-w-[200px] sm:max-w-none">
          {formatUserDisplay()}
        </span>
      </div>

      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full bg-gray-100 text-gray-700 hover:text-gray-900 hover:bg-gray-200"
          aria-label={t('backoffice.navbar.notifications')}
        >
          <Bell className="h-4 w-4" />
        </Button>
        <LanguageSwitcherBackoffice />
      </div>
    </header>
  );
};

export default BackofficeNavbar;
